// extracted by mini-css-extract-plugin
export default {"container":"Footnote_container__XcOLN"};